var tabbed_content = () => {
  const prefix = '.tabbed_content';

  if (exists(prefix)) {
    const component = document.querySelectorAll(prefix)[0],
      nav = component.querySelector(`${prefix}-nav`),
      title = component.querySelector(`${prefix}-title`),
      main = component.querySelector(`${prefix}-main`),
      allTabs = nav.querySelectorAll(`button${prefix}-tab`),
      loop = Number(component.getAttribute('loop') || false);

    let cursor = 0,
      hasClicked = false,
      prevLoop = null;

    const styleBlob = (blobId, selectedTab) => {
      for (let i = 0; i < allTabs.length; i++) {
        const tab = allTabs[i],
          span = tab.getElementsByTagName('span')[0];

        if (span.classList.length >= 1) {
          span.removeAttribute('class');
          if (span.parentElement.classList.contains('active')) {
            span.parentElement.classList.remove('active');
          }
          span.parentElement.classList.add('active');
        }
      }

      const item = nav.querySelector(`[data-tab=${selectedTab}] span`)

      item.classList.add(`tabbed_content_blob--${blobId}`);

      title.innerHTML = "";
      title.appendChild(item.cloneNode(true));
    };

    const showContent = attr => {
      if (
        main.getElementsByClassName(`active`)[0].getAttribute('data-tab') !=
        attr
      ) {
        main.getElementsByClassName(`active`)[0].classList.remove(`active`);
        main.querySelector(`[data-tab=${attr}]`).classList.add(`active`);
      }
    };

    const swap = node => {
      const selectedTab = node.getAttribute('data-tab');
      const blobId = node.getAttribute('data-blob-id');
      styleBlob(blobId, selectedTab);
      showContent(selectedTab);
    };

    cancelLoop = () => {
      hasClicked = true;
      clearTimeout(prevLoop);
    };

    const startLoop = () => {
      prevLoop = setTimeout(() => {
        cursor = (cursor + 1) % allTabs.length;
        const current = Array.from(allTabs)[cursor];
        swap(current);
        startLoop();
      }, +loop);
    };

    for (let i = 0; i < allTabs.length; i++) {
      const tab = allTabs[i];
      tab.addEventListener('click', function() {
        cancelLoop();
        swap(this);
      });
    }

    if (loop > 0) startLoop();
  }
};

tabbed_content();
